import axios from '@/libs/axios';
import { ErrorMessage } from '@/libs/Error';

export default class SlsTipoPicClient {
  constructor() {
    this.api = axios;
    this.error = new ErrorMessage();
  }

  async getItems(queries = {}) {
    try {
      const { data } = await this.api.get('/tipo-pic');
      return data;
    } catch (error) {
      throw this.error.message(error, 'Erro ao listar as Tipo Pic');
    }
  }

  async index(queries = {}) {
    try {
      return await this.api.get('/tipo-pic', { params: queries });
    } catch (error) {
      throw this.error.message(error, 'Erro ao listar as Tipo Pic');
    }
  }

  async store(data) {
    try {
      const { data: response } = await this.api.post('/tipo-pic', data);
      return response;
    } catch (error) {
      throw error;
    }
  }

  async show(id) {
    try {
      const { data } = await this.api.get(`/tipo-pic/${id}`);
      return data;
    } catch (error) {
      throw this.error.message(error, 'Erro ao buscar a Tipo Pic');
    }
  }

  async update(id, data) {
    try {
      const { data: response } = await this.api.put(`/tipo-pic/${id}`, data);
      return response;
    } catch (error) {
      throw this.error.message(error, 'Erro ao atualizar a Tipo Pic');
    }
  }

  async destroy(id) {
    try {
      const { data: response } = await this.api.delete(`/tipo-pic/${id}`);
      return response;
    } catch (error) {
      throw this.error.message(error, 'Erro ao deletar a Tipo Pic');
    }
  }
}
